import React from 'react';
import { useStyletron } from 'baseui';
import type { AnnotationLabelT } from '../../../../../../../common/types/types';
type PropsT = {
  annotationId: string;
  annotationLabel: AnnotationLabelT;
  Icon?: (a: {
    strokeColor?: string;
  }) => React.ReactNode;
};
const LABEL_FONT_WEIGHT = 500;
export const AnnotationHeader = ({
  annotationId,
  annotationLabel,
  Icon
}: PropsT) => {
  const [css, theme] = useStyletron();
  return <div className={css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.sizing.scale300
  })}>
      {Icon && <Icon strokeColor={annotationLabel.style.strokeColor} />}
      <div className={css({
      fontSize: theme.typography.LabelMedium.fontSize,
      textTransform: 'capitalize',
      fontWeight: LABEL_FONT_WEIGHT
    })}>{`${annotationLabel.title} [${annotationId}]`}</div>
    </div>;
};